import styled from "@emotion/styled"
import { Grid, Typography } from "@mui/material"
import * as api from "api"
import { getUploadURL } from "api"
import VehicleCatalogsIcon from "components/icons/VehicleCatalogsIcon"
import { memo } from "react"
import Shared from "theme/shared"

const pdfFile = "(קובץ PDF)"

const Styled = {
  Wrapper: styled.div`
    margin: 50px 0;
  `,
  Grid: styled(Grid)`
    justify-content: center;
    ${(p) => p.theme.breakpoints.down("sm")} {
      flex-direction: column;
    }
  `,
  Catalog: styled(Grid)`
    align-items: center;
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 305px;
      margin: 10px 0px;
      :not(:first-of-type) {
        margin-inline-start: 70px;
      }
    }
  `,
  InnerGrid: styled(Grid)`
    color: ${(p) => p.theme.colors.duskBlue};
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding: 10px 15px 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
    }
    svg {
      width: auto;
      height: 30px;
    }

    .icon {
      margin: 0 10px;
    }

    .details {
      ${(p) => p.theme.breakpoints.up("md")} {
        flex: 1;
        width: 150px;
      }
    }

    ${(p) => p.theme.breakpoints.up("md")} {
      padding: 40px;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0 15px 25px 0 ${(p) => p.theme.colors.darkIndigo};
      border: solid 1px ${(p) => p.theme.colors.darkIndigo};
      background-color: ${(p) => p.theme.colors.white};
      flex-direction: column;

      svg {
        height: 64px;
      }
    }
  `,
  Item: styled(Grid)`
    display: flex;
    justify-content: center;
  `,
  Title: styled(Typography)`
    font-size: 20px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.duskBlue};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 24px;
    }
  `,
  Type: styled(Typography)`
    font-size: 14px;
    font-weight: 500;
    color: ${(p) => p.theme.colors.bluishGrey};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
      font-weight: normal;
    }
  `,
}
type VehicleCatalogsProps = { data: api.VehicleCatalogs[] }

const VehicleCatalogs = ({ data }: VehicleCatalogsProps) => {
  const items = data.filter((d) => !!d.link && !!d.name)
  return (
    <Styled.Wrapper>
      <Styled.Grid container>
        {items.map((item, i) => (
          <Styled.Catalog key={i} item>
            <Shared.Mobile>
              <Shared.Divider />
            </Shared.Mobile>
            <a href={getUploadURL(item.link)} target="_blank" rel="noreferrer">
              <Styled.InnerGrid container alignItems="center">
                <Styled.Item item className="icon">
                  <VehicleCatalogsIcon type={item.typeId} />
                </Styled.Item>
                <Grid item className="details">
                  <Styled.Title>{item.name}</Styled.Title>
                  <Styled.Type>{pdfFile}</Styled.Type>
                </Grid>
              </Styled.InnerGrid>
            </a>
          </Styled.Catalog>
        ))}
        {data.length > 0 && (
          <Shared.Mobile>
            <Shared.Divider />
          </Shared.Mobile>
        )}
      </Styled.Grid>
    </Styled.Wrapper>
  )
}

export default memo(VehicleCatalogs)
